import axios from 'axios'

axios.defaults.timeout = 15000
axios.defaults.baseURL = process.env.VUE_APP_BASE_URL



axios.interceptors.response.use(
    response => {
        if (response.data.code === '100') {
            alert('登录信息失效', '提示');
        }
        return response.data
    },
    error => {
        return Promise.reject(error)
    })

export default axios
